<template>
  <v-card    
    height="100%"
    style="box-shadow: 15px 15px 40px #00000029; border-radius: 20px;"
  >
    <div class="pa-4 pl-8 secondary--text">
      <v-card-title class="font-weight-bold px-0">
        <div class="d-flex">
          Overview
        </div>
        <!-- <v-btn
          icon
          color="accent"
          class="btn--plain"
          @click="''"
        >
          <v-icon>mdi-pencil-outline</v-icon>
        </v-btn> -->
        <v-spacer />
        <div>
          <v-btn
            v-show="!showAll"
            icon
            color="primary"
            class="btn--plain"
            @click="showAll = true"
          >
            <v-icon large>
              mdi-menu-down
            </v-icon>
          </v-btn>
          <v-btn
            v-show="showAll"
            icon
            color="primary"
            class="btn--plain"
            @click="showAll = false"
          >
            <v-icon large>
              mdi-menu-up
            </v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-container
        v-if="showAll"
        fluid
        class="pa-0"
      >
        <v-row>
          <v-col>
            <div>
              <p class="overline info--text font-weight-bold mb-1">
                drafted
              </p>
              <p
                v-if="courtInfo.filed"
                class="spaced-text mb-0"
              >
                {{ courtInfo.filed }}
              </p>
              <p
                v-else
                class="spaced-text mb-0"
              >
                {{ currentCase.statusDate }}
              </p>
            </div>
          </v-col>
          <v-col>
            <div>
              <p class="overline info--text font-weight-bold mb-1">
                ground
              </p>
              <p class="spaced-text mb-0">
                Non-Payment of Rent
              </p>
            </div>
          </v-col>
          <v-col>
            <div>
              <p class="overline info--text font-weight-bold mb-1">
                judge
              </p>
              <p 
                class="spaced-text mb-0" 
                style="color: #8BA4B4"
              >
                Pending
              </p>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div>
              <p class="overline info--text font-weight-bold mb-1">
                hearing
              </p>
              <p
                v-if="courtInfo.hearing"
                class="spaced-text mb-0"
                style="color: #8BA4B4"
              >
                {{ courtInfo.hearing }}
              </p>
              <p
                v-else
                class="spaced-text"
                style="color: #8BA4B4"
              >
                Pending
              </p>
            </div>
          </v-col>
          <v-col>
            <div>
              <p class="overline info--text font-weight-bold mb-1">
                suit amount
              </p>
              <p class="spaced-text mb-0">
                {{ getInitialSuitAmount(currentCase) }}
              </p>
            </div>
          </v-col>
          <v-col>
            <div>
              <p class="overline info--text font-weight-bold mb-1">
                county
              </p>
              <p class="spaced-text mb-0">
                {{ currentCase.property.county }}
              </p>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div>
              <p class="overline info--text font-weight-bold mb-1">
                docket no.
              </p>
              <p 
                class="spaced-text mb-0" 
                style="color: #8BA4B4"
              >
                {{ currentCase.docketNo? currentCase.docketNo : 'Pending' }}
              </p>
            </div>
          </v-col>
          <v-col>
            <div>
              <p class="overline info--text font-weight-bold mb-1">
                lease type
              </p>
              <p class="spaced-text mb-0">
                {{ currentCase.leaseTypeTitle }}
              </p>
            </div>
          </v-col>
          <v-col>
            <div>
              <p class="overline info--text font-weight-bold mb-1">
                court contact
              </p>
              <p class="spaced-text mb-0">
                {{ mileage.courtAddress && mileage.courtAddress.phone }}
              </p>              
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div>
              <p class="overline info--text font-weight-bold mb-1">
                parties
              </p>
              <p class="spaced-text mb-0 pr-5">
                {{ currentCase.property.deedNames }} vs. {{ compileTenants(currentCase.tenants) }}
              </p>
            </div>
          </v-col>
          <v-col>
            <div>
              <p class="overline info--text font-weight-bold mb-1">
                property address
              </p>
              <p class="spaced-text mb-0">
                {{ currentCase.property.streetAddress }}<span v-if="currentCase.property.unitNo">, {{ currentCase.property.unitNo }}</span>
              </p>
              <p class="spaced-text mb-0">
                {{ currentCase.property.city }}, {{ currentCase.property.state }} {{ currentCase.property.zipcode }}
              </p>
            </div>
          </v-col>
          <v-col>
            <div>
              <p class="overline info--text font-weight-bold mb-1">
                court address
              </p>
              <p class="spaced-text mb-0">
                {{ mileage.courtAddress && mileage.courtAddress.county }} County Justice Center
              </p>
              <p class="spaced-text mb-0">
                {{ mileage.courtAddress && mileage.courtAddress.street }}
              </p>
              <p class="spaced-text mb-0">
                {{ mileage.courtAddress && mileage.courtAddress.city }}, {{ mileage.courtAddress && mileage.courtAddress.state }} {{ mileage.courtAddress && mileage.courtAddress.zipcode }}
              </p>
              <p class="spaced-text mb-0">
                {{ mileage.courtAddress && mileage.courtAddress.phone }} ext. {{ mileage.courtAddress && mileage.courtAddress.ext }}
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>      
    </div>
    <div class="card-action-bottom d-flex align-items-center">
      <h3 class="primary--text font-weight-medium mr-2">
        LATEST STATUS
      </h3>
      <!-- <p class="secondary--text font-weight-medium mr-2 mb-0">
        {{ currentCase.status }}
      </p>
      <div class="secondary--text font-weight-medium mr-2">
        |
      </div>
      <div class="secondary--text mr-2">
        <span class="font-weight-medium">Filed:</span> 
        <span>{{ currentCase.statusDate }}</span>
      </div> -->
      <span class="px-2 secondary--text font-weight-medium">Verified Complaint | </span>
      <span class="secondary--text font-weight-medium">Filed: {{ currentCase.statusDate }}</span>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: 'CaseOverviewCard',
  props:{
    currentCase: {
      type: Object,
      default: () => {}
    },
  },
  data(){
    return{
      courtInfo: {
        street:'1123 Broadway Ave.',
        city: 'Newark',
        state: 'NJ',
        zip: '99938',
        judge: 'Hon. Walters',
      },
      showAll: true,
    }
  },
  computed: {
    ...mapGetters({
      mileage:"eviction/mileage"
    }),
  },
  async created() {    
    await this.$store.dispatch("eviction/loadMileage");
  },  
  methods: {
    compileTenants(tenants) {
      let tenantsCompiled = "";
      //TODO: when pull data, check this works
      if (tenants.tenantCompanyName){
        return tenants.tenantCompanyName
      }
      for (let i = 0; i < tenants.length; i++) {
        if(tenants.length - 2 === i) {
          tenantsCompiled += `${tenants[i].name} ` + `and `;
        } else if(tenants.length - 1 === i) {
          tenantsCompiled += tenants[i].name;
        } else {
          tenantsCompiled += `${tenants[i].name}` + `, `
        }
      }
      return tenantsCompiled;
    },
    changeNumToCurrency(num) {
      if (!num) return "$0.00";
      return `$${parseFloat(num)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}`;
    },
    calculateTotal(arr) {
      let total = 0;
      arr.forEach((item) => {
        if (item.amount && item.selected) {
          total += parseFloat(item.amount);
        }
      });
      return total;
    },
    getInitialSuitAmount(item) {
      let totalMoney = 0;
      [
        "lateCharges",
        "utilities",
        "fees",
        "otherCharges",
        "pastDueRent",
        "legalFees",
      ].forEach((property) => {
        try {
          if (item[property] === null || item[property] === undefined) return;
          totalMoney += this.calculateTotal(item[property]);
        } catch (e) {
          return e;
        }
      });

      return this.changeNumToCurrency(totalMoney);
    },      
  }

}
</script>

<style>

</style>